document.addEventListener("DOMContentLoaded", function() {
  AbTestPacks();
});

function AbTestPacks() {
  var unitWrapper = document.querySelector(".unit-wrapper-btn");
  var packSizeWrapper = document.querySelector(".product-pack__wrapper");
  var contentForPacks = document.querySelector(".content-for-packs");
  var packSizeElements = document.querySelectorAll(".pack-size");
  var testContent = document.querySelector("#content-test");
  var twoPackLabel = document.querySelector(".two-pack-hidden");
  var unitPackLabel = document.querySelector(".unit-pack-label");
  if (testContent !== null && testContent.classList.contains("hidden")) {
    testContent.classList.remove("hidden");
  }
  if (twoPackLabel !== null && twoPackLabel.classList.contains("hidden")) {
    twoPackLabel.classList.remove("hidden");
  }
  if (unitPackLabel !== null && !unitPackLabel.classList.contains("hidden")) {
    unitPackLabel.classList.add("hidden");
  }

  if (packSizeElements.length > 0) {
    packSizeElements.forEach(function (element) {
      if (!element.classList.contains("unit-pack-label")) {
        element.addEventListener("click", function () { 
          if (testContent.classList.contains("hidden")) {
            testContent.classList.remove("hidden");
            document
              .querySelector(".pack-size__list-bottom")
              ?.classList.remove("hidden");
          }
        });
      }
    });
  }
  if (unitWrapper && testContent && packSizeWrapper && contentForPacks) {
    unitWrapper.addEventListener("click", function () {
      loadUnitPack(testContent, contentForPacks, packSizeWrapper);
    });
  }
  const currentUrl = window.location.href;
  if (!currentUrl.includes("bundle=")) {
    loadUnitPack(testContent, contentForPacks, packSizeWrapper);
  }
}

function loadUnitPack(testContent, contentForPacks, packSizeWrapper) {
  if (!testContent.classList.contains("hidden")) {
    testContent.classList.add("hidden");
  }
  document.querySelector(".pack-size__list-bottom")?.classList.add("hidden");
  if (document.querySelector(".unit-pack-label")) {
    document.querySelector(".unit-pack-label").click();
  }
  if (contentForPacks && packSizeWrapper) {
    contentForPacks.appendChild(packSizeWrapper);
  }
}
